export default __webpack_public_path__ + "static/media/flag-united-kingdom.7f8e70fa.svg";